var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPriceSlip(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 317,
    height: 94,
    viewBox: "0 0 317 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12C0 5.37258 5.37258 0 12 0H305C311.627 0 317 5.37258 317 12V34C309.636 34.0002 303.667 39.9696 303.667 47.3333C303.667 54.697 309.636 60.6665 317 60.6667V82C317 88.6274 311.627 94 305 94H12C5.37259 94 0 88.6274 0 82V60.6626C0.110781 60.6653 0.221897 60.6667 0.333333 60.6667C7.69713 60.6667 13.6667 54.6971 13.6667 47.3333C13.6667 39.9695 7.69713 34 0.333333 34C0.221897 34 0.110781 34.0014 0 34.0041V12Z",
    fill: "#4E81F4",
    fillOpacity: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPriceSlip);
export default __webpack_public_path__ + "static/media/priceSlip.7591d9e9dac606794683bb672dfe5c4b.svg";
export { ForwardRef as ReactComponent };